import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit, input, output, model, effect, viewChild } from '@angular/core';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { UiWindowService, UserSummary } from '../../../../../modules/fwcore';
import { UserListComponent } from '../../../../admin';

@Component({
  selector: 'app-user-list-dlg',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonsModule, UserListComponent],
  templateUrl: './user-list-dlg.component.html',
  styleUrl: './user-list-dlg.component.scss'
})
export class UserListDlgComponent implements OnInit, AfterViewInit {
    
  // -------------- Input/Outputs --------------------------------------------
    
  public show = model<boolean>(false);

  public heading = input<string>("Select User(s)");
  public description = input<string>("Currently selected users");

  public filterCompanyId = input<string | null>(null);

  public filterCompanyIdWithExternals = input<string | null>(null);

  public filterCompanyIdExternalsOnly = input<string | null>(null);

  public filterUserGroupCode = input<string | null>(null);

  /**
 * Filter by user authorization code
 */
  public filterAuthAppCode = input<string | null>(null);

  public userCheckedIds = input<string[]>([]);

  /**
   * If user selects ok UserSummary array returned zero or many items, otherwise if cancel then null.
   */
  public close = output<UserSummary[] | null>();

  //-------------------------- Internal properties  --------------------

  protected compUsers = viewChild<UserListComponent>("userList");

  //--------------------------- Constructor  --------------------------

  constructor(protected afUiWin: UiWindowService) {

  }

  //--------------------------- ng  -----------------------------------

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {

    this.compUsers()?.Initialized();
  }
    
  /*--------------------------- event handlers  --------------------------*/

  protected onClose(e: PointerEvent): void {

    e.preventDefault();

    let users: UserSummary[] = this.compUsers()?.getCheckedItems() ?? [];

    this.show.set(false);
    this.close.emit(users);
  }

  protected onCancel(): void {

    this.show.set(false);
    this.close.emit(null);
  }

}
